import { render } from "./ProfilePanel.vue?vue&type=template&id=04f607e8&scoped=true"
import script from "./ProfilePanel.vue?vue&type=script&lang=js"
export * from "./ProfilePanel.vue?vue&type=script&lang=js"

import "./ProfilePanel.vue?vue&type=style&index=0&id=04f607e8&lang=scss&scoped=true"

import exportComponent from "/Users/vonwong/Dropbox/ClaudeCode/MeetingOS/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f607e8"]])

export default __exports__